export const SET_POSSIBLE_SITES = 'SITE_ACTION_SET_POSSIBLE_SITES'
export const SET_ALL_SITES = 'SITE_ACTION_SET_ALL_SITES'
export const SET_SITE = 'SITE_ACTION_SET_SITE'
export const UPDATE_SITES_PAGINATION = 'SITE_ACTION_UPDATE_SITES_PAGINATION'
export const UPDATE_SITE_SEARCH_TERM = 'SITE_ACTION_UPDATE_SITE_SEARCH_TERM'
export const UPDATE_SHOW_FOOTER = 'UPDATE_SHOW_FOOTER'
